module.exports = __webpack_public_path__ + "static/media/user (1).a2fe8661.svg";